import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { PHONE_DISPLAY, TEL_HREF, EMAIL, MAILTO, NMLS_URL } from "@/data/content";

export default function Privacy() {
  return (
    <div>
      <Seo
        title="Privacy Policy | Family First Mortgage USA"
        description="Privacy policy for Family First Mortgage USA — what information this website collects and how it is used."
      />
      <PageHeader line1="Privacy" line2="Policy." />

      <section className="bg-white py-16 md:py-20">
        <div className="wrap max-w-3xl space-y-8 text-sm leading-relaxed text-ink" data-testid="privacy-body">
          <p>
            Family First Mortgage USA, empowered by NEXA Lending (&ldquo;we&rdquo;, &ldquo;us&rdquo;), respects your
            privacy. This page explains what information this website collects and how it is used.
          </p>

          <div>
            <h2 className="font-serif text-xl font-bold text-navy">Information We Collect</h2>
            <p className="mt-3">
              This website is informational. It does not host mortgage applications and does not collect or store your
              personal information on this site. If you use the contact form, your details are handed to your own
              email application so you can send them directly to us; we receive only what you choose to send.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-xl font-bold text-navy">How We Use Information</h2>
            <p className="mt-3">
              Information you send us by email or phone is used solely to respond to your inquiry and, if you proceed,
              to process your mortgage request. Mortgage applications and the personal financial information they
              contain are handled through our brokerage, not through this website.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-xl font-bold text-navy">Sharing of Information</h2>
            <p className="mt-3">
              We do not sell your personal information. Any information you provide is shared only as needed to
              respond to you or, with your involvement, to evaluate and process a loan request.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-xl font-bold text-navy">Licensing</h2>
            <p className="mt-3">
              Family First Mortgage USA, empowered by NEXA Lending. Branch NMLS #2729829 | Personal NMLS #2142845. You
              can review our licensing through the{" "}
              <a
                href={NMLS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold underline underline-offset-2"
                data-testid="privacy-nmls-link"
              >
                NMLS Consumer Access
              </a>{" "}
              portal.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-xl font-bold text-navy">Contact Us</h2>
            <p className="mt-3">
              Questions about this policy? Call{" "}
              <a href={TEL_HREF} className="font-medium text-navy underline underline-offset-2" data-testid="privacy-phone">
                {PHONE_DISPLAY}
              </a>
              , email{" "}
              <a href={MAILTO} className="font-medium text-navy underline underline-offset-2" data-testid="privacy-email">
                {EMAIL}
              </a>
              , or write to 6185 Deltona Blvd, Spring Hill, FL 34606.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
